import { Autocomplete } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';
import ChevronDown from 'mdi-material-ui/ChevronDown';

import { ControlContainer } from 'app/components/ControlContainer';
import { AutocompleteControlProps } from './AutocompleteControl.interfaces';
import { useStyles } from './AutocompleteControl.styles';
import { useAutocompleteControl } from './useAutocompleteControl';

export default function AutocompleteControl(props: AutocompleteControlProps) {
  const {
    input,
    meta,
    label,
    dictionary = [],
    placeholder,
    tooltip,
    helperText,
    width,
    disabled,
    labelAboveInputField,
  } = props;

  const classes = useStyles();
  const {
    focused,
    setFocused,
    error,
    selectedOption,
    handleChange,
    handleBlur,
  } = useAutocompleteControl(props);

  return (
    <ControlContainer
      inputId={input.name}
      tooltip={tooltip}
      disabled={!!disabled}
      meta={meta}
      width={width}
      helperText={helperText}
      label={labelAboveInputField ? label || '' : ''}
      focused={focused}
    >
      <Autocomplete
        id={input.name}
        className={classes.root}
        options={dictionary}
        getOptionLabel={(option) => option.value || ''}
        value={selectedOption}
        onChange={handleChange}
        disabled={!!disabled}
        noOptionsText="Brak opcji"
        popupIcon={<ChevronDown />}
        classes={{
          popupIndicator: classes.popupIndicator,
          inputRoot: classes.inputRoot,
          paper: classes.paper,
          listbox: classes.listbox,
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name={input.name}
            label={!labelAboveInputField ? label : undefined}
            placeholder={!selectedOption ? placeholder : undefined}
            error={error}
            variant="outlined"
            margin="dense"
            onFocus={() => setFocused(true)}
            onBlur={handleBlur}
            InputProps={{
              ...params.InputProps,
              startAdornment: !selectedOption ? (
                <InputAdornment position="start" className={classes.searchIcon}>
                  <Search />
                </InputAdornment>
              ) : undefined,
            }}
          />
        )}
      />
    </ControlContainer>
  );
}
